import { makeStyles, css } from '@conexasaude/hero-web'
import { keyframes } from '@emotion/react'
import { UseStylesProps } from './types'

const colorFromVariant = {
  success: 'success',
  warning: 'warning',
  information: 'info',
  error: 'danger',
}

const fadeIn = keyframes`
  from {
    transform: translate3d(0, -5px, 0);
    opacity: 0;
    visibility: hidden;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
    visibility: visible;
  }

`

const useStyles = makeStyles<UseStylesProps>({
  root: theme => css`
    display: flex;
    padding: 16px 0;
    box-shadow: ${theme.shadows[0]};
    box-sizing: border-box;
    transition: 0.2s;
    animation: ${fadeIn} 0.5s forwards;
    margin-bottom: 24px;

    @media (max-width: 639px) {
      margin: -16px 0 0 -16px;
      padding-left: 16px;
      padding-right: 16px;
      width: 100vw;
      margin-bottom: 12px;
    }
  `,

  wrapper: () => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 32px;

    @media (max-width: 639px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  `,

  content: () => css`
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 639px) {
      align-items: flex-start;

      > p {
        padding-top: 6px;
      }
    }
  `,

  textWrapper: () => css`
    display: flex;
    flex-direction: column;
  `,

  iconWrapper: (theme, props) => {
    const variant = colorFromVariant[props.variant]

    return css`
      display: flex;
      background-color: ${theme?.colors?.[variant]?.[100] || 'initial'};
      padding: 10px;
      border-radius: 8px;
    `
  },

  actions: () => css`
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 639px) {
      align-self: flex-end;
    }
  `,

  actionButton: () => css`
    &:disabled {
      background-color: transparent !important;
    }
  `,

  closeButton: () => css`
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
  `,
})

export { useStyles }
